// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2lwGz","title":"InfoRow_title__13TC7"};